export { default } from './PageRoutes.vue'
